module.exports = __webpack_public_path__ + "img/itsm11.da4ca6c4.png";